import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { HiOutlineMail,HiOutlineTrash,HiOutlineChatAlt2,HiOutlinePhoneOutgoing,HiInformationCircle, HiAdjustments } from "react-icons/hi";

const DetailTransaction = ({ setIsAuthenticated }) => {
  const { gphone } = useParams();
  const navigate = useNavigate();
  const [propData, setPropData] = useState([]);
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const [isModalRateTransaction, setModalRateTransaction] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [guestDetail, setDetailGuest] = useState(null);  // Initialize as null
  const [listRateTransaction,setListRateTransaction] = useState([]);

  const chooseProperty = async (hotel, url) => {
    navigate(`/property/${hotel}/${url}`);
  };

  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Failed to fetch hotel details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch hotel details");
    } finally {
      setLoading(false);
    }
  };

  const getDetailBreakdownRate = async (book_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/transaction/guest/${book_id}`);
      // console.log(response.data)
      if (response.status === 200) {
        setListRateTransaction(response.data.data);
        setModalRateTransaction(true)
      } else {
        throw new Error("Failed to fetch hotel details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch hotel details");
    } finally {
      setLoading(false);
    }
  };

  const sendConfirmEmail = async (book_id) => { 
    setLoading(true);
    try {
      const response = await axios.get(`/api/send/confirmation/letter/${book_id}`);
      alert(response.data.message)
      // if (response.status === 200) {
      //   setListRateTransaction(response.data.data);
      //   setModalRateTransaction(true)
      // } else {
      //   throw new Error("Failed to fetch hotel details");
      // }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch hotel details");
    } finally {
      setLoading(false);
    }
  }

  // Calculate total transaction price only when guestDetail is available
  const totalTransactionPrice = guestDetail?.history?.reduce((total, transaction) => {
    return total + Math.round(transaction.price);
  }, 0) || 0;  // Default to 0 if guestDetail or history is undefined

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    getDetailProperty(userHID)
    const fetchData = async () => {
      if (gphone) {
        setLoading(true);
        try {
          const response = await axios.post("/api/detail/guest", { gphone }, {
            headers: { "Content-Type": "application/json" },
          });

          if (response.status === 200 && response.data.data.length > 0) {
            setDetailGuest(response.data.data[0]);
            // console.log(response.data.data[0]);
          
          } else {
            throw new Error("Failed to fetch guest details");
          }
        } catch (err) {
          console.error("Error fetching data:", err);
          alert("An error occurred while fetching data.");
        } finally {
          setLoading(false);
        }
      } else {
        navigate("/"); // Navigate to home if phone is not provided
      }
    };
    fetchData();
  }, [gphone]); // Fetch data only when the phone number changes

 // Return a loading state or an error if data is not loaded yet
if (isLoading) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0f1827] mb-4"></div>
        <p className="text-gray-700">Load Data...</p>
      </div>
    </div>
  );
}

if (!guestDetail) {
  return (
    <div className="flex justify-center items-center h-screen">
      <div>No guest data available.</div>
    </div>
  );
}


return (
  <div className="flex h-screen bg-gray-200">
    {/* Sidebar */}
    <Sidebar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} propertyID={propData.ID_HOTEL || "Loading..."}/>

    {/* Main Content */}
    <div className="flex-1 flex flex-col overflow-hidden">
      {/* Topbar */}
      <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />

      {/* Main Section */}
      <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
        {/* Breadcrumb */}
        <div className="mb-2 text-sm text-[#101827]">
          <span>Guest Detail</span> &gt;{" "}
          <span>Transaction</span>
        </div>

        <div className=" min-h-screen p-2">
          <div className=" mx-auto bg-white p-8 rounded-xl shadow-lg">
            {/* Profile Header */}
            <div className="flex items-center space-x-6">
              <img
                src={'https://www.shutterstock.com/image-vector/avatar-gender-neutral-silhouette-vector-600nw-2470054311.jpg'} // Fallback image
                alt="User Avatar"
                className="rounded-full w-32 h-32 object-cover border-2 border-gray-300"
              />
              <div>
                <h2 className="text-lg font-bold">{guestDetail.salutation} {guestDetail.guest}</h2> {/* Display Guest Name */}
                <p className="text-gray-500">{guestDetail.email}</p> {/* Display Email */}
                <p className="text-gray-600">{guestDetail.phone}</p> {/* Display Phone */}
                <div className="mt-4 flex space-x-3">
                  
                <a href={`tel:${guestDetail.phone}`} className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center space-x-2">
                  <HiOutlinePhoneOutgoing className="text-sm" /> {/* Icon */}
                  <span className="text-sm">Call</span> {/* Text */}
                </a>
                <a
                  href={`https://wa.me/${guestDetail.phone}?text=Hello%20${guestDetail.guest},%20I%20want%20to%20inform%20 `}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 bg-green-600 text-white text-sm rounded-lg flex items-center"
                >
                  <HiOutlineChatAlt2/> {" "}
                  <span className="ml-1 text-sm">WhatsApp</span> {/* Add text for the button */}
                  <i className="fab fa-whatsapp"></i> {/* Add WhatsApp icon */}
                </a>
                </div>
              </div>
            </div>

            {/* Additional Guest Info */}
            <div className="mt-8 grid text-sm grid-cols-1 md:grid-cols-4 gap-6">
              <div>
                <h3 className="font-semibold text-xs">Full Name</h3>
                <p className="text-gray-600">{guestDetail.guest}</p>
              </div>
              <div>
                <h3 className="font-semibold text-xs">Email</h3>
                <p className="text-gray-600">{guestDetail.email}</p>
              </div>
              <div>
                <h3 className="font-semibold text-xs">Phone</h3>
                <p className="text-gray-600">{guestDetail.phone}</p>
              </div>

              <div>
                <h3 className="font-semibold text-xs">Total Transaction</h3>
                <p className="text-gray-600">
                  {new Intl.NumberFormat('id-ID', {
                    style: 'currency',
                    currency: 'IDR',
                    minimumFractionDigits: 0, 
                    maximumFractionDigits: 0  
                  }).format(totalTransactionPrice)}  {/* Display the total price */}
                </p>
              </div>
            </div>

            {/* Transaction History */}
            <div className="mt-8">
              <h3 className="text-sm font-semibold">Transaction History</h3>
              <ul className="mt-2">
                {guestDetail.history && guestDetail.history.map((transaction, index) => (
                  <li key={index} className="bg-gray-100 p-4 text-xs rounded-lg mb-4 shadow-sm">
                    <div className="flex items-center space-x-4 mb-2">
                      <img
                        src={transaction.LOGO_HOTEL || "https://via.placeholder.com/80"}
                        alt={transaction.NAME_HOTEL || "Hotel Logo"}
                        className="w-14 h-14 rounded-full border-2 bg-white border-gray-200 p-1 shadow-lg object-scale-down"
                      />
                      <div>
                        <p className="text-base text-slate-600 font-bold">{transaction.NAME_HOTEL}</p>
                        <p className="font-medium">{transaction.booking_id}</p>
                        <p className="font-light text-[11px] mb-2">Transaction: {moment(transaction.date_trans).format('LLL')}</p>
                      </div>
                    </div>

                    
                    <p className="font-semibold text-indigo-400 text-sm ">
                      Total Cost: { 
                        new Intl.NumberFormat('id-ID', {
                          style: 'currency',
                          currency: 'IDR',
                          minimumFractionDigits: 0, // No decimal places
                          maximumFractionDigits: 0  // No decimal places
                        }).format(Math.round(transaction.price)) // Round and format the price
                      }
                    </p>

                     <p className="text-red-600 font-bold text-xs mb-2"> {transaction.room}</p>

                    <p className="text-gray-600 text-xs">Arrival: {moment(transaction.arrival_date).format('LL')}</p>
                    <p className="text-gray-600 text-xs">Departure: {moment(transaction.departure_date).format('LL')}</p>

                    {/* Buttons for Send Confirmation Email and Delete */}
                    <div className="mt-4 flex space-x-4">

                      {/* Send Confirmation Email Button */}
                      <button onClick={() => sendConfirmEmail(transaction.booking_id)} className="px-4 py-2 bg-orange-500 text-white rounded-lg flex items-center">
                        <HiOutlineMail className="mr-2" /> Send Confirmation Email
                      </button>

                      {/* Send Confirmation Email Button */}
                      <button onClick={() => {alert(`Sending confirmation email to ${guestDetail.email}`);}}className="px-4 py-2 bg-slate-500 text-white rounded-lg flex items-center">
                        <HiAdjustments className="mr-2" /> Register Reservation to PMS
                      </button>
                      

                      {/* Detail Breakdown */}
                      <button  onClick={() => {getDetailBreakdownRate(transaction.booking_id)}} className="px-4 py-2 bg-blue-500 text-white rounded-lg flex items-center">
                        <HiInformationCircle className="mr-2" />Detail Transaction
                      </button>
                      

                      {/* Delete Button */}
                      <button onClick={() => {alert(`Deleting transaction ID: ${transaction.booking_id}`);}} className="px-4 py-2 bg-red-600 text-white rounded-lg flex items-center">
                        <HiOutlineTrash className="mr-2" />
                        Delete
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
      </main>
    </div>

    {/* Rate Breakdown Modal */}
    {isModalRateTransaction && (
      <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg w-3/4 max-w-4xl">
          <div className="flex justify-between items-center">
            <h3 className="text-sm font-bold">Rate Breakdown</h3>
            <button onClick={() => setModalRateTransaction(false)} className="text-gray-500 hover:text-gray-700 text-2xl">
              &times;
            </button>
          </div>
          <div className="mt-4">
            {listRateTransaction && listRateTransaction.length > 0 ? (
              <>
                <table className="min-w-full table-auto">
                  <thead className="text-sm">
                    <tr className="border-b">
                      <th className="py-2 px-4 text-left">Room Rate</th>
                      <th className="py-2 px-4 text-left">From</th>
                      <th className="py-2 px-4 text-left">To</th>
                      <th className="py-2 px-4 text-left">Price Room</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listRateTransaction.map((rate) => (
                      <tr key={rate.ID_RATE} className="border-b text-xs">
                        <td className="py-2 px-4">{rate.ROOM_NAME} {rate.NAME_RATE}</td>
                        <td className="py-2 px-4">{rate.FROM_DATE}</td>
                        <td className="py-2 px-4">{rate.TO_DATE}</td>
                        <td className="py-2 px-4">
                          {new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            maximumFractionDigits: 0,  // Remove decimal places
                            minimumFractionDigits: 0,  // Remove decimal places
                          }).format(rate.PRICE_ROOM)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Total Price */}
                <div className="mt-4 font-semibold text-sm text-right">
                  <span>Total Price: </span>
                  <span>
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    }).format(
                      listRateTransaction.reduce((total, rate) => total + rate.PRICE_ROOM, 0)
                    )}
                  </span>
                </div>
              </>
            ) : (
              <p>No rate details available.</p>
            )}
          </div>
          <div className="mt-4 text-right">
            <button
              onClick={() => setModalRateTransaction(false)}
              className="px-4 py-2 bg-gray-500 text-white rounded-md"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )}


  </div>
);

};

export default DetailTransaction;
